import { render, staticRenderFns } from "./TenantRentManagement.vue?vue&type=template&id=6abe2c80&scoped=true&"
import script from "./TenantRentManagement.vue?vue&type=script&lang=js&"
export * from "./TenantRentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe2c80",
  null
  
)

export default component.exports